module.exports = __webpack_public_path__ + "img/stuff_01.4e2c077.png";